// @ts-nocheck
import React from 'react';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import { ConfirmDeleteDialog } from '../../../components/ConfirmDeleteDialog';
import type { Deployment } from '../../../api/deploymentsApi';

interface DeploymentDeleteDialogProps {
  deployment: Deployment | null;
  open: boolean;
  loading?: boolean;
  error?: string | null;
  onConfirm: () => void;
  onClose: () => void;
}

export const DeploymentDeleteDialog = ({
  deployment,
  open,
  loading = false,
  error = null,
  onConfirm,
  onClose,
}: DeploymentDeleteDialogProps) => {
  const { t } = useTranslation();
  if (!deployment) return null;

  const dates = `${dayjs(deployment.start_date).format('DD/MM/YYYY')}${
    deployment.end_date
      ? ` → ${dayjs(deployment.end_date).format('DD/MM/YYYY')}`
      : ''
  }`;

  return (
    <ConfirmDeleteDialog
      open={open}
      title={t('Delete this deployment?')}
      description={t('The deployment below will be deleted')}
      details={[
        { label: t('Name'), value: deployment.name, emphasis: true },
        { label: t('Service Desk'), value: `SD ${deployment.service_desk_id}` },
        { label: t('Dates'), value: dates },
      ]}
      loading={loading}
      error={error}
      confirmLabel={t('Delete')}
      cancelLabel={t('Cancel')}
      onConfirm={onConfirm}
      onClose={onClose}
    />
  );
};
